import React, {useEffect, useState} from 'react'
import CartItem from './CartItem';
import {ArrowLeftOutlined} from '@ant-design/icons';
import {Button, Divider} from 'antd';
import {useSelector} from "react-redux";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {setLocalStorageCart} from 'utils/cart';
import {useDispatch} from "react-redux";
import { changePromotionsQuantity} from 'redux/actions';
import {APP_PREFIX_PATH} from 'configs/AppConfig';
import {Link, useHistory} from 'react-router-dom';
import './cart.css';


function ReviewCart() {
    const {theme: {direction, locale}, cartData: {cartQuantity, homePromotion}, fetchedData: {storeData}} = useSelector(state => state);
    const [cartItems, setCartItems] = useState([]);
    const [promotions, setPromotions] = useState(0)
    const history = useHistory();
    const dispatch = useDispatch()

    useEffect(() => {
        setCartItems(setLocalStorageCart());
    }, [cartQuantity]);

    const subTotal = cartItems?.reduce((acc, cur) => acc + (cur.itemTotal), 0);
    const taxPrice = cartItems?.reduce((acc, cur) => acc + cur.taxPrice, 0);
    const delivery = JSON.parse(localStorage.getItem('selected-area'))?.template.deliveryFee;
    const currency = storeData?.currency?.name ? storeData?.currency.name : "KWD";
    const selected_mode = localStorage.getItem('selected-mode');


    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
        if (localStorage.getItem('applied-voucher')){
            dispatch(changePromotionsQuantity(JSON.parse(localStorage.getItem('applied-voucher'))))
        }else{
            dispatch(changePromotionsQuantity({}))
        }
    },[])

    useEffect(()=>{
        if (homePromotion?.minimumPurchase <= (subTotal+taxPrice+((!homePromotion?.freeDelivery && selected_mode === 'pickup' ? 0 : delivery)))){
            if (homePromotion?.discountType === 'AMOUNT'){
                setPromotions(homePromotion.amount)
            }else{
                setPromotions((subTotal+taxPrice+(homePromotion?.freeDelivery || selected_mode === 'pickup' ? 0 : delivery))*(homePromotion.amount/100))
            }
        }
    }, [homePromotion])

    return (
        <div className="d-flex flex-column cartContainer">
            <div className='relative d-flex align-items-center p-3'>
                <div onClick={() => {
                        if (localStorage.getItem('location')) {
                            localStorage.removeItem('location');
                            window.history.go(-3)
                        }else{
                            window.history.back();
                        }
                    }} style={{position: 'absolute'}}
                >
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0}
                                       style={{fontSize: '24px', cursor: 'pointer', color: 'black'}}/>
                </div>
                <div className='text-center w-100 font-bold text-black' style={{fontSize: '20px'}}>Review Cart</div>
            </div>
            <Divider className='mt-0 mb-2'/>
            {cartItems?.length > 0 ? <div className='m-3 ' style={{position: 'relative'}}>
                <h4 className='text-black'>Order Items</h4>
                {cartItems.map(item => <div key={item.id+item.price}>
                    <CartItem item={item} locale={locale} currency={currency}/>
                </div>)}
                <div>
                    <div className='d-flex align-items-center justify-content-between mb-1'>
                        <div>Subtotal</div>
                        <div>{currency} {subTotal.toFixed(3)}</div>
                    </div>
                    {selected_mode === 'pickup' || homePromotion?.freeDelivery ? '' :
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>Delivery</div>
                        <div>{currency} {delivery.toFixed(3)}</div>
                    </div>}
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>Tax</div>
                        <div>{currency} {taxPrice.toFixed(3)}</div>
                    </div>
                    {homePromotion?.id && <div style={{color:'var(--primaryColor)'}} className=' mt-2 d-flex align-items-center justify-content-between'>
                        <div>Voucher Discount</div>
                        <div>
                            {currency} {promotions.toFixed(3)} 
                            {homePromotion?.freeDelivery && <span className='font-16'> + Free Delivery</span>}
                        </div>
                    </div>}
                </div>
                <Divider className='my-2 '/>
                <h4 className="d-flex justify-content-between text-black font-16 font-bold">
                    <span>Total</span>
                    <span>{currency} {(subTotal + (homePromotion?.freeDelivery || selected_mode === 'pickup' ? 0 : delivery) + taxPrice - promotions).toFixed(3)}</span>
                </h4>
                <Divider className='my-2 cartTotalDivider'/>
            </div> : <div className={'h-100'}>
                <div style={{height: "100%"}} className='d-flex align-items-center justify-content-center'>
                    <div className='d-flex flex-column align-items-center justify-content-center'>
                        <img src='/img/emptyCart.svg' alt="search"/>
                        <div className="mt-4 text-center px-2" style={{fontSize: "24px", color: 'black'}}>Your Cart is
                            Empty
                        </div>
                        <div className='mt-2 text-center px-4' style={{fontSize: "16px", color: '#616161'}}>Browse
                            products and add them to cart to place an order
                        </div>
                        <div className='mt-3 '>
                            <Link to={APP_PREFIX_PATH + '/menu'} style={{color:'var(--primaryColor)'}}>Start Ordering</Link>
                        </div>
                    </div>
                </div>
            </div>}
            {cartItems?.length > 0 && 
            <div className='orderCheckoutContainer'>
                <Button className='w-100 orderCheckout primaryColor' onClick={() => history.push("checkOut")}> Orderfast Checkout </Button>
            </div>}
        </div>
    )
}

export default ReviewCart